module.exports = __webpack_public_path__ + "img/negative.afdcaa84.png";